import { useRef, useState } from 'react';

import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { LicitacaoStatusProcesso } from '../site/features/licitacao/types/Licitacao';
import useLicitacaoStatusProcessoSiteFetch from './useLicitacaoStatusProcessoSiteFetch';

type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: LicitacaoStatusProcesso | null;
  handleSearchChange: (newValue: LicitacaoStatusProcesso) => void;
};

const TxtLicitacaoStatusProcessoSite = ({
  isdisabled,
  isLoading,

  required,
  value,
  handleSearchChange
}: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState('');
  const { options } = useLicitacaoStatusProcessoSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => {
        const licitacaoStatusProcesso = option as LicitacaoStatusProcesso;
        let descricao: string = '';
        if (!licitacaoStatusProcesso) {
          return '';
        }

        if (licitacaoStatusProcesso.nome) {
          descricao = licitacaoStatusProcesso.nome;
        }
        return descricao;
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as LicitacaoStatusProcesso);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Status do Processo"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
export default TxtLicitacaoStatusProcessoSite;
